import {
  IItinerary,
  IFlightResult,
  IFlightSegment,
  useConfig,
} from "@thekilroygroup/shared-ui";
import { useFetchAirlinesQuery } from "../redux/services/airlinesSearch";
import { useIataLookupQuery } from "../redux/services/iataLookup";
import { decodeHtmlEntities } from "./helpers";

/**
 * Fetches the airport details via useFetchAirportsQuery() and returns:
 * - AIRPORT NAME || ""
 * @param iata
 */
export const getAirportDetails = (iata: string) => {
  const { appConfig } = useConfig();

  const result = useIataLookupQuery(
    {
      iata: iata,
      config: appConfig,
    },
    { skip: iata === "" || iata === null },
  );

  return result;
};

/**
 *
 * @param iata
 * @returns
 */
export const getAirportName = (iata: string) => {
  const ap = getAirportDetails(iata);
  if (!ap.isFetching && !ap.isError) {
    return decodeHtmlEntities(ap.data.locationName);
  }
  return "";
};

/**
 *
 * @param iata
 * @returns
 */
export const getCity = (iata: string) => {
  const ap = getAirportDetails(iata);
  if (!ap.isFetching && !ap.isError) {
    return `${decodeHtmlEntities(ap.data.cityName)} [${iata}]`;
  }
  return "";
};

/**
 *
 * @param iata
 * @returns
 */
export const getCityName = (iata: string) => {
  const ap = getAirportDetails(iata);
  if (!ap.isFetching && !ap.isError) {
    return decodeHtmlEntities(ap.data.cityName);
  }
  return "";
};

/**
 *
 * @param data
 * @param airlineType
 * @param specificity
 * @returns
 */
export const getAirlineNames = (
  data: IItinerary | IFlightResult | IFlightSegment,
  airlineType: "marketingAirline" | "operatingAirline",
  specificity: "itinerary" | "flight" | "flightSegment",
) => {
  let iatas: string = "";

  if (specificity === "itinerary") {
    const flights = (data as IItinerary).flights;
    const ia = flights.map((flight: IFlightResult) =>
      flight.flightSegments.map(
        (segment: IFlightSegment) => segment[airlineType],
      ),
    );
    iatas = ia.join();
  } else if (specificity === "flight") {
    const flightSegments = (data as IFlightResult).flightSegments;
    const ia = flightSegments.map(
      (segment: IFlightSegment) => segment[airlineType],
    );
    iatas = ia.join();
  } else if (specificity === "flightSegment") {
    iatas = (data as IFlightSegment)[airlineType];
  }

  const { appConfig } = useConfig();

  const result = useFetchAirlinesQuery({
    query: iatas,
    limit: 20,
    config: appConfig,
  });

  if (!result.isFetching && !result.isError) {
    return Object.values(result.data).join(", ");
  }
  return "";
};
